import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { apiGetCarrito, apiAddCarrito, apiRemoveCarrito } from "../lib/marketplaceApi";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user || user === false) { setCount(0); return; }
    try {
      const d = await apiGetCarrito();
      setCount(d.cantidad || 0);
    } catch (_) { /* noop */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = useCallback(async (tipo, itemId) => {
    const d = await apiAddCarrito(tipo, itemId);
    setCount(d.cantidad || 0);
    return d;
  }, []);

  const remove = useCallback(async (tipo, itemId) => {
    const d = await apiRemoveCarrito(tipo, itemId);
    setCount(d.cantidad || 0);
    return d;
  }, []);

  return <CartCtx.Provider value={{ count, refresh, add, remove }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx) || { count: 0, refresh: () => {}, add: async () => {}, remove: async () => {} };
